import {
  ApiBlueprint,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  gitlabAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { gitlabPipelinesTab } from './content';
import { GitlabPipelinesApiClient } from './GitlabPipelinesApiClient';

// Upstream alpha exports the UI but does not register this API on the plugin.
// See GitlabPipelinesApiClient.ts for why a local factory is still required.

export const gitlabPipelinesApiRef =
  createApiRef<GitlabPipelinesApiClient>().with({
    id: 'plugin.gitlabpipelines',
  });

const gitlabPipelinesApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: gitlabPipelinesApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        gitlabAuthApi: gitlabAuthApiRef,
      },
      factory: ({ discoveryApi, fetchApi, gitlabAuthApi }) =>
        new GitlabPipelinesApiClient({
          discoveryApi,
          fetchApi,
          gitlabAuthApi,
        }),
    }),
});

export const gitlabPipelinesApiModule = createFrontendModule({
  pluginId: 'gitlab-pipelines',
  extensions: [gitlabPipelinesApi, gitlabPipelinesTab],
});
